import { IEnvironment } from '@am/_types';
import { IBaseEnvironment } from '@arturin/core';

// Values are inlined at build time from the .env file (or real env vars in CI)
// via webpack DefinePlugin — see webpack.config.js and .env.example.
// Dev/prod separation happens on the Jenkins side; there is no dev/prod split in code.

const backEndUrl = process.env.BACKEND_URL;

export const baseEnvironment: IBaseEnvironment = {
  accessManagerUrl: process.env.ACCESS_MANAGER_URL,
  baseDomain: process.env.BASE_DOMAIN,
  backEndUrl,
  successBackOfficeUrl: backEndUrl,
  enableAngularProdMode: process.env.ENABLE_PROD_MODE === 'true',
};

export const environment: IEnvironment = {
  ...baseEnvironment,
  apiUrl: `${backEndUrl}/`,
  recaptchaKey: process.env.RECAPTCHA_KEY,
};
